import { render, staticRenderFns } from "./MVMFooter.vue?vue&type=template&id=68721080&"
import script from "./MVMFooter.vue?vue&type=script&lang=js&"
export * from "./MVMFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports